var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_370_2520)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 17,
    r: 17,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2071 14.6744L22.6414 14.6739C22.2631 14.6739 21.9565 14.9805 21.9565 15.3587V18.0951C21.9565 18.4733 22.2631 18.7799 22.6413 18.7799H27.465C26.9368 20.1507 25.951 21.2987 24.6932 22.0281L26.75 25.5886C30.0494 23.6804 32 20.3324 32 16.5845C32 16.0508 31.9607 15.6693 31.882 15.2398C31.8222 14.9134 31.5389 14.6744 31.2071 14.6744Z",
    fill: "#167EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.8913C19.1394 22.8913 17.0786 21.6015 15.9718 19.6929L12.4114 21.7451C14.2233 24.8854 17.6175 27 21.5 27C23.4046 27 25.2018 26.4872 26.75 25.5935L26.75 25.5886L24.6932 22.028C23.7524 22.5737 22.6637 22.8913 21.5 22.8913Z",
    fill: "#12B347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 25.5935L26.75 25.5886L24.6932 22.028C23.7524 22.5737 22.6637 22.8913 21.5 22.8913V27C23.4046 27 25.2019 26.4872 26.75 25.5935Z",
    fill: "#0F993E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1087 16.5C15.1087 15.3364 15.4262 14.2478 15.9718 13.3071L12.4114 11.2549C11.5128 12.7982 11 14.5905 11 16.5C11 18.4095 11.5128 20.2018 12.4114 21.7451L15.9718 19.6929C15.4262 18.7522 15.1087 17.6636 15.1087 16.5Z",
    fill: "#FFD500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.1087C23.0394 10.1087 24.4533 10.6557 25.5578 11.5655C25.8302 11.79 26.2262 11.7738 26.4758 11.5242L28.4146 9.58538C28.6978 9.30221 28.6776 8.83869 28.3751 8.57627C26.5247 6.97096 24.1171 6 21.5 6C17.6175 6 14.2233 8.11464 12.4114 11.2549L15.9718 13.3071C17.0786 11.3985 19.1394 10.1087 21.5 10.1087Z",
    fill: "#FF4B26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5578 11.5655C25.8302 11.79 26.2262 11.7738 26.4758 11.5242L28.4146 9.58538C28.6978 9.30221 28.6776 8.83869 28.3751 8.57627C26.5247 6.97096 24.1171 6 21.5 6V10.1087C23.0394 10.1087 24.4533 10.6557 25.5578 11.5655Z",
    fill: "#D93F21"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_370_2520",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_370_2520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_370_2520",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.3b0d1b0403b4e4e87678056b52961aad.svg";
export { ForwardRef as ReactComponent };